import { render, staticRenderFns } from "./WidgetAlerta.vue?vue&type=template&id=de9e5b1a&"
import script from "./WidgetAlerta.vue?vue&type=script&lang=ts&"
export * from "./WidgetAlerta.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetAlerta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('de9e5b1a', component.options)
    } else {
      api.reload('de9e5b1a', component.options)
    }
    module.hot.accept("./WidgetAlerta.vue?vue&type=template&id=de9e5b1a&", function () {
      api.rerender('de9e5b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Alertas/WidgetAlerta.vue"
export default component.exports